import { render } from "./Tabset.vue?vue&type=template&id=12baeb1f"
import script from "./Tabset.vue?vue&type=script&lang=js"
export * from "./Tabset.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__